export default "__VITE_ASSET__DFIeNhqq__"